export default __webpack_public_path__ + "static/media/Art.a25301c5.webp";